module.exports = __webpack_public_path__ + "img/242-madagascar.c94c7483.svg";